import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { IbanGatewayManipulationView } from "./ibanGatewayManipulation-view"

export class IbanGatewayManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("ibanGatewayManipulation-viewModel.defineIban", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ibanGateway = ObservableArray.create<ibanGateway>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new IbanGatewayManipulationView();
    }
    public getTypeId(): string {
        return "VM-E359F1E2-5BFB-4933-911E-9374B18A5BF8"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set ibanGateway(v: ObservableArray<ibanGateway>) { this._ibanGateway = v; } public get ibanGateway(): ObservableArray<ibanGateway> { return this._ibanGateway; } private _ibanGateway: ObservableArray<ibanGateway>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAllIbanGateway', {
                FilteringInformation: filteringInformation
            });
            this.ibanGateway.update(...result.IbanGateway.map((q, i) => {
                let r = new ibanGateway(this);
                r.id = q.Id;
                r.rowNumber = i + 1;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.accountId = q.AccountId;
                r.accountName = q.AccountName;
                r.serialNumber = q.SerialNumber;
                r.needConfirmation = q.NeedConfirmation;
                r.createDate = moment.utc(q.CreateDate);
                r.removeDate = q.RemoveDate == null ? null : moment.utc(q.RemoveDate);
                r.canInvalidate = q.RemoveDate == null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestIbanGatewayCreation() {
        let editor = new ibanGatewayEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async ibanGatewayUpdater(ibanGateway: ibanGateway) {
        let editor = new ibanGatewayEditor(this, new UpdateServerUpdater());
        ibanGateway.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async accept(id: any) {
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/ArapRawDataServices/InvalidateGateway', {
                GatewayId: id
            });
            await this.messageBoxConfirmSuccess(translate("ibanGatewayManipulation-viewModel.IbanDeactivated", {}), translate("ibanGatewayManipulation-viewModel.successfulOperation", {}));
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("ibanGatewayManipulation-viewModel.operationErorr", {}), translate("ibanGatewayManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class ibanGateway extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: IbanGatewayManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set serialNumber(v: string) { this._serialNumber = v; } public get serialNumber(): string { return this._serialNumber; } private _serialNumber: string;
    public set needConfirmation(v: boolean) { this._needConfirmation = v; } public get needConfirmation(): boolean { return this._needConfirmation; } private _needConfirmation: boolean;
    public set createDate(v: moment.Moment) { this._createDate = v; } public get createDate(): moment.Moment { return this._createDate; } private _createDate: moment.Moment;
    public set removeDate(v: moment.Moment) { this._removeDate = v; } public get removeDate(): moment.Moment { return this._removeDate; } private _removeDate: moment.Moment;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate; } private _canInvalidate: boolean;

    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId; } private _accountId: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName; } private _accountName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName; } private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId; } private _bankId: string;

    private _typedParent: IbanGatewayManipulationViewModel;

    cloneTo(ibanGateway: ibanGateway) {
        ibanGateway.id = this.id;
        ibanGateway.serialNumber = this.serialNumber;
        ibanGateway.needConfirmation = this.needConfirmation;
        ibanGateway.setAccount(this.getAccountId(), this.accountName);
    }

    setAccount(id: string, name: string) {
        this.accountId = id;
        this.accountName = name;
    }
    getAccountId() {
        return this.accountId;
    }

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }

    async inactiveIbanGateway(): Promise<void> {
        if (this.canInvalidate) {
            let result: string;
            result = await this.messageBoxWarningYesNo(translate("ibanGatewayManipulation-viewModel.sureQuestion", {}), translate("ibanGatewayManipulation-viewModel.deactivateCard", {}));
            if (result == 'yes') {
                this._typedParent.accept(this.id);
            }
        }
    }

    async edit() {
        this._typedParent.ibanGatewayUpdater(this);
    }
}

interface IServerUpdater {
    execute(ibanGateway: ibanGateway): Promise<void>;
    getSuccessMessage(): string;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("ibanGatewayManipulation-viewModel.successfullyRegistered", {});
    }
    async execute(ibanGateway: ibanGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreateIbanGateway', {
            AccountId: ibanGateway.getAccountId(),
            SerialNumber: ibanGateway.serialNumber,
            NeedConfirmation: ibanGateway.needConfirmation,
        });
        if (result.IsSuccessful == false) {
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw translate("ibanGatewayManipulation-viewModel.duplicateIban", {});
            throw translate("ibanGatewayManipulation-viewModel.operationErorr", {});
        }
    }
}

class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("ibanGatewayManipulation-viewModel.successfullyUpdated", {});
    }
    async execute(ibanGateway: ibanGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdateIbanGateway', {
            Id: ibanGateway.id,
            AccountId: ibanGateway.getAccountId(),
            SerialNumber: ibanGateway.serialNumber,
            NeedConfirmation: ibanGateway.needConfirmation,
        });
        if (result.IsSuccessful == false) {
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw translate("ibanGatewayManipulation-viewModel.duplicateIban", {});
            throw translate("ibanGatewayManipulation-viewModel.operationErorr", {});
        }
    }
}

export class ibanGatewayEditor extends ibanGateway implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: IbanGatewayManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.accountSelector = new AccountGatewaySelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;
    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector; } private _accountSelector: AccountGatewaySelectorViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.serialNumber)) {
            result.push(translate("ibanGatewayManipulation-viewModel.IbanNumberError", {}));
        }
        if (stringIsNullOrEmpty(this.getAccountId())) {
            result.push(translate("ibanGatewayManipulation-viewModel.accountError", {}));
        }
        return result;
    }

    setAccount(id: string, name: string) {
        this.accountSelector.selectById(id);
    }

    getAccountId() {
        return this.accountSelector.selectedItem?.accountId;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("ibanGatewayManipulation-viewModel.notPossibleToRegister", {}));
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), translate("ibanGatewayManipulation-viewModel.successfulOperation", {}));
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("ibanGatewayManipulation-viewModel.operationErorr", {}), translate("ibanGatewayManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }

}

